var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(!_vm.waiting)?_c('router-view'):_vm._e()],1),_c('AutoclubConfirm',{ref:"confirm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }